import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import edelmetallKonditionen from "../type/edelmetallKonditionen";
import sortenKonditionen from "../type/sortenKonditionen";
import KonditionenStorage from "../storage/konditionen-storage";
import console from "../utils/functions/console";
import { basketActions, configActions, currenciesActions, metalsActions } from "../actions";
import CONFIG from "../config";

export const fetchData = createAsyncThunk("konditionen/fetchData", async ({ requestData, appType }) => {
  if (!requestData || !requestData.url) return {};
  let {
    konditionenKey,
    konditionenListe,
    defaultKeys,
    defaultBetrag,
    listKeys
  } = appType === "edelmetall" ? edelmetallKonditionen : sortenKonditionen;
  const { request, json, params } = requestData;
  let url = requestData.url;
  if (params && params.gpNummer) {
    url = url + "?GpNummer=" + Number(params.gpNummer);
  }
  const { type, config } = request || {};
  //neue axios instanz erzeugt, damit interceptor nicht hier greift
  let axiosCall = axios.create(config);
  const response = await axiosCall[type || "get"](url, json);
  if (response && response.data && response.data[konditionenKey] && response.data[konditionenKey][konditionenListe]) {
    const defaultWerte = (defaultKeys || []).map(defaultKey => {
      if (!isNaN(response.data[defaultKey])) {
        return Number(response.data[defaultKey]);
      } else if (defaultKey.match(/MaBuy/)) {
        const bpKey = defaultKey.replace(/MaBuy/, "BpBuy");
        return !isNaN(response.data[bpKey]) ? Number(response.data[bpKey]) : 0;
      }
      return 0;
    });
    const defaultBetraege = (defaultBetrag || []).map(defaultKey => {
      if (!isNaN(response.data[defaultKey])) {
        return Number(response.data[defaultKey]);
      } else if (defaultKey.match(/MaBuy/)) {
        const bpKey = defaultKey.replace(/MaBuy/, "BpBuy");
        return !isNaN(response.data[bpKey]) ? Number(response.data[bpKey]) : 0;
      }
      return 0;
    });
    return {
      konditionenListe: response.data[konditionenKey][konditionenListe],
      defaultWerte,
      defaultBetraege,
      listKeys
    };
  } else {
    return {
      type: "ERROR",
      error: new Error("Die Konditionen konnten nicht geladen werden")
    };
  }
});

export const patchData = createAsyncThunk("konditionen/patchData", async ({ requestData, kennziffer }) => {
  if (!requestData || !requestData.url) return {};
  let { url, request, json } = requestData || {};
  url = url + kennziffer;
  const { type, config } = request || {};
  //neue axios instanz erzeugt, damit interceptor nicht hier greift
  let axiosCall = axios.create(config);
  const response = await axiosCall[type || "patch"](url, json);
  if (response.status && response.status < 300) {
    return response.data;
  } else {
    return {
      type: "ERROR",
      error: new Error("Die Konditionen konnten nicht gespeichert werden")
    };
  }
});

export const resetData = createAsyncThunk("konditionen/resetData", async ({ requestData, reset }) => {
  if (!requestData || !requestData.url) return {};
  let url = requestData.url;
  url = url + reset;
  const data = requestData.json || {};
  const { type, config } = requestData.request || {};
  //neue axios instanz erzeugt, damit interceptor nicht hier greift
  let axiosCall = axios.create(config);
  const response = await axiosCall[type || "post"](url, data);
  if (response.status && response.status < 300) {
    return response.data;
  } else {
    return {
      type: "ERROR",
      error: new Error("Die Konditionen konnten nicht zurückgesetzt werden")
    };
  }
});

export const fetchStufen = createAsyncThunk("konditionen/fetchStufen", async ({ requestData, appType }) => {
  if (!requestData || !requestData.url) return {};
  let {
    konditionenKey,
    stufenKonditionen,
  } = appType === "edelmetall" ? edelmetallKonditionen : sortenKonditionen;
  const { request, json, params } = requestData;
  let url = requestData.url;
  if (params && params.gpNummer) {
    url = url + "?GpNummer=" + Number(params.gpNummer);
  }
  const { type, config } = request || {};
  //neue axios instanz erzeugt, damit interceptor nicht hier greift
  let axiosCall = axios.create(config);
  const response = await axiosCall[type || "get"](url, json);
  if (response.data && response.data[konditionenKey] && response.data[konditionenKey][stufenKonditionen]) {
    return {
      stufenKonditionen: response.data[konditionenKey][stufenKonditionen],
      updated: response.data.updated,
      modifiedBy: response.data.modifiedBy,
    };
  } else {
    return {
      type: "ERROR",
      error: new Error("Die Konditionenstufen konnten nicht geladen werden")
    };
  }
});

export const setStufen = createAsyncThunk("konditionen/setStufen", async ({ requestData, stufenData, appType }) => {
  if (!requestData || !requestData.url) return {};
  let {
    konditionenKey,
    stufenKonditionen
  } = appType === "edelmetall" ? edelmetallKonditionen : sortenKonditionen;
  const { url, json, request } = requestData;
  const { config } = request || {};
  let data = { ...json };
  data[konditionenKey] = {};
  data[konditionenKey][stufenKonditionen] = stufenData;
  //neue axios instanz erzeugt, damit interceptor nicht hier greift
  let axiosCall = axios.create(config);
  const response = await axiosCall.post(url, data);
  if (response.data && response.data[konditionenKey] && response.data[konditionenKey][stufenKonditionen]) {
    return {
      stufenKonditionen: response.data[konditionenKey][stufenKonditionen]
    };
  } else {
    return {
      type: "ERROR",
      error: new Error("Die Konditionenstufen konnten nicht gespeichert werden")
    };
  }
});

export const fetchKonditionenAbsolut = createAsyncThunk("konditionen/fetchKonditionenAbsolut", async ({ requestData, appType }) => {
  if (!requestData || !requestData.url) return {};
  const { request, json, params } = requestData;
  if (json.updated) {
    delete json.updated;
  }
  let url = requestData.url;
  if (params && params.gpNummer) {
    url = url + "?GpNummer=" + Number(params.gpNummer);
  }
  const { type, config } = request || {};
  //neue axios instanz erzeugt, damit interceptor nicht hier greift
  let axiosCall = axios.create(config);
  const response = await axiosCall[type || "get"](url, json);
  if (response.data && response.data.konditionenAbsolut) {
    return {
      konditionenAbsolut: response.data.konditionenAbsolut,
      updated: response.data.updated,
      modifiedBy: response.data.modifiedBy,
    };
  } else {
    return {
      type: "ERROR",
      error: new Error("Die Konditionen Absolut konnten nicht geladen werden")
    };
  }
});

export const setKonditionenAbsolut = createAsyncThunk("konditionen/setKonditionenAbsolut", async ({ requestData, absolutData, appType }) => {
  if (!requestData || !requestData.url) return {};
  const { url, json, request } = requestData;
  const { config } = request || {};

  // Create a new payload containing only the header from the original request and the new DTO.
  const payload = {
    header: json.header,
    konditionenAbsolut: absolutData
  };

  // Create a new axios instance to avoid interceptor issues.
  let axiosCall = axios.create(config);
  // Ensure we are using the POST method and sending the clean payload.
  const response = await axiosCall.post(url, payload);

  if (response.data) {
    return {
      konditionenAbsolut: response.data
    };
  } else {
    return {
      type: "ERROR",
      error: new Error("Die Konditionen Absolut konnten nicht gespeichert werden")
    };
  }
});

export const resetKonditionenAbsolut = createAsyncThunk("konditionen/resetKonditionenAbsolut", async ({ requestData, resetField }) => {
  if (!requestData || !requestData.url) return {};
  let url = requestData.url;
  // Append the specific reset field to the URL
  url = url + resetField;
  const data = requestData.json || {};
  const { type, config } = requestData.request || {};

  // neue axios instanz erzeugt, damit interceptor nicht hier greift
  let axiosCall = axios.create(config);
  const response = await axiosCall[type || "post"](url, data);

  if (response.status && response.status < 300) {
    return response.data;
  } else {
    return {
      type: "ERROR",
      error: new Error("Die absoluten Konditionen konnten nicht zurückgesetzt werden")
    };
  }
});



export const resetKonditionStufe = createAsyncThunk("konditionen/resetKonditionStufe", async ({ requestData, resetEndpoint }) => {
  if (!requestData || !requestData.url) return {};
  let url = requestData.url;

  // Ensure no double slash
  if (url.endsWith("/")) {
    url = url + resetEndpoint;
  } else {
    url = url + "/" + resetEndpoint;
  }

  const { config } = requestData.request || {};
  const data = requestData.json || {};
  let axiosCall = axios.create(config);

  try {
    const response = await axiosCall.post(url, data);
    if (response.status && response.status < 300) {
      return response.data;
    } else {
      throw new Error("Fehler beim Zurücksetzen");
    }
  } catch (e) {
    return {
      type: "ERROR",
      error: new Error("Die Konditionsstufe konnte nicht zurückgesetzt werden")
    };
  }
});

export const setMaKond = (isMaKond) => (dispatch, getState) => {
  const dataAction = CONFIG.getShopConfig({ edelmetall: metalsActions, sorten: currenciesActions });
  const { configStorage } = getState();
    dispatch(configActions.setMitarbeiterKonditionen(isMaKond));
    dispatch(configActions.loadingMaKond(true));    
    return dispatch(basketActions.fetchMasterData(configStorage.getRequestData("masterdata")))
      .then(() => {
        return dispatch(dataAction.fetchListData(configStorage.getRequestData("catalog")));
      })
      .catch((err) => {
        console.error("m3", err);
        dispatch(configActions.setMitarbeiterKonditionen(!isMaKond));
        throw new Error("m2: Ein Übertragungsfehler ist aufgetreten");
      })
      .finally(() => {
        dispatch(configActions.loadingMaKond(false));
      });
};

const konditionenSlice = createSlice({
  name: "konditionen",
  initialState: new KonditionenStorage(),
  reducers: {
    setAll(state, action) {
      state.all = action.payload.basedata;
    },
    getItems(state) {
      return state.getItems();
    },
    setStufen(state, action) {
      state.all = action.payload.basedata;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.failed(null);
        return state;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        let res = action.payload;
        if (res && res.konditionenListe) {
          state.setAll(res.konditionenListe, res.defaultWerte, res.listKeys, res.defaultBetraege);
        } else {
          state.failed(res ? res.error : new Error("m4: Ein Übertragungsfehler ist aufgetreten"));
        }
        return state;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.failed(action.error);
        return state;
      })
      .addCase(patchData.pending, (state) => {
        state.failed(null);
        return state;
      })
      .addCase(patchData.fulfilled, (state, action) => {
        let res = action.payload;
        if (res && res.type !== "ERROR") {
          state.setKondition(res);
        } else {
          state.failed(res ? res.error : new Error("m4: Ein Übertragungsfehler ist aufgetreten"));
        }
        return state;
      })
      .addCase(patchData.rejected, (state, action) => {
        state.failed(action.error);
        return state;
      })
      .addCase(resetData.pending, (state) => {
        state.failed(null);
        return state;
      })
      .addCase(resetData.fulfilled, (state, action) => {
        let res = action.payload;
        if (res && res.type !== "ERROR") {
          console.log("resetData", res);
        } else {
          state.failed(res ? res.error : new Error("m3: Ein Übertragungsfehler ist aufgetreten"));
        }
        return state;
      })
      .addCase(resetData.rejected, (state, action) => {
        state.failed(action.error);
        return state;
      })
      .addCase(fetchStufen.pending, (state) => {
        state.failedStufen(null);
        return state;
      })
      .addCase(fetchStufen.fulfilled, (state, action) => {
        let res = action.payload;
        if (res && res.stufenKonditionen) {
          state.setStufen(res.stufenKonditionen, res.updated, res.modifiedBy);
        }
        return state;
      })
      .addCase(fetchStufen.rejected, (state, action) => {
        state.failedStufen(action.error);
        return state;
      })
      .addCase(setStufen.pending, (state) => {
        state.failed(null);
        return state;
      })
      .addCase(setStufen.fulfilled, (state, action) => {
        let res = action.payload;
        if (res && res.stufenKonditionen && res.type !== "ERROR") {
          state.setStufen(res.stufenKonditionen);
        } else {
          state.failed(res ? res.error : new Error("m3: Ein Übertragungsfehler ist aufgetreten"));
        }
        return state;
      })
      .addCase(setStufen.rejected, (state, action) => {
        state.failed(action.error);
        return state;
      })
      .addCase(fetchKonditionenAbsolut.pending, (state) => {
        state.failedStufen(null);
        return state;
      })
      .addCase(fetchKonditionenAbsolut.fulfilled, (state, action) => {
        let res = action.payload;
        if (res && res.konditionenAbsolut) {
          console.log("setKonditionenAbsolut modifiedBy: ", res.modifiedBy);
          state.setKonditionenAbsolut(res.konditionenAbsolut, res.updated, res.modifiedBy);
        }
        return state;
      })
      .addCase(fetchKonditionenAbsolut.rejected, (state, action) => {
        state.failedStufen(action.error);
        return state;
      })
      .addCase(setKonditionenAbsolut.pending, (state) => {
        state.failed(null);
        return state;
      })
      .addCase(setKonditionenAbsolut.fulfilled, (state, action) => {
        let res = action.payload;
        if (res && res.konditionenAbsolut && res.type !== "ERROR") {
          state.setKonditionenAbsolut(res.konditionenAbsolut);
        } else {
          state.failed(res ? res.error : new Error("m3: Ein Übertragungsfehler ist aufgetreten"));
        }
        return state;
      })
      .addCase(setKonditionenAbsolut.rejected, (state, action) => {
        state.failed(action.error);
        return state;
      })
      .addCase(resetKonditionenAbsolut.pending, (state) => {
        state.failed(null);
        return state;
      })
      .addCase(resetKonditionenAbsolut.fulfilled, (state, action) => {
        let res = action.payload;
        if (res && res.type !== "ERROR") {
          console.log("resetKonditionenAbsolut", res);
        } else {
          state.failed(res ? res.error : new Error("m3: Ein Übertragungsfehler ist aufgetreten"));
        }
        return state;
      })
      .addCase(resetKonditionenAbsolut.rejected, (state, action) => {
        state.failed(action.error);
        return state;
      })
      .addCase(resetKonditionStufe.pending, (state) => {
        state.failed(null);
        return state;
      })
      .addCase(resetKonditionStufe.fulfilled, (state, action) => {
        let res = action.payload;
        if (res && res.type !== "ERROR") {
          console.log("resetKonditionStufe", res);
        } else {
          state.failed(res ? res.error : new Error("m3: Ein Übertragungsfehler ist aufgetreten"));
        }
        return state;
      })
      .addCase(resetKonditionStufe.rejected, (state, action) => {
        state.failed(action.error);
        return state;
      });
  }
});
export const { setAll, getItems } = konditionenSlice.actions;
export const konditionenActions = { ...konditionenSlice.actions, setMaKond };
export default konditionenSlice.reducer;
